import { ChangeRequestTable } from "@/app/Bookings/Components/ChangeRequestTable";
import {
  BookingChangeRequestStatus,
  QueryBookingChangeRequestsWhereColumn,
  SqlOperator,
} from "@/gql/graphql";

export function DashboardPendingChangeRequests() {
  return (
    <ChangeRequestTable
      id={"dashboard-pending-change-requests"}
      queryVariables={{
        where: {
          column: QueryBookingChangeRequestsWhereColumn.Status,
          operator: SqlOperator.In,
          value: [
            BookingChangeRequestStatus.Pending,
            BookingChangeRequestStatus.Actioned,
          ],
        },
      }}
    />
  );
}
